"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @hidden
 *
 * An object which contains the information about the cities within the timezone.
 */
exports.timezones = {
    rules: {},
    titles: {},
    zones: {}
};
